<app-header></app-header>
<ngx-spinner></ngx-spinner>
<section class="content-pages wrapper">
  <div class="container" *ngIf="data && !errStatus">
    <div>
      <div class="row">
        <div class="col-12 col-md-12 ">
          <div class="bg-white">
            <h2 class="font-24 font-bold">
              {{ data?.title }}
            </h2>
            <p [innerHTML]="data?.content"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="record-not-available" *ngIf="data?.length == 0">
    <div class="text-center">
      <img src="assets/images/no-recoard-playlist.png" />
      <p class="no-recored-content text-secondary">{{ "RECORD_NOT_FOUND" | translate }}</p>
    </div>
  </div>
</section>
<app-footer></app-footer>